// import logo from './logo.svg';
import { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap'
import { BrowserRouter as Router } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
//import UserContext from '../UserContext';

//components
import AppNavbar from './components/AppNavbar';

//pages
import Products from './pages/Products';
import ProductView from './pages/ProductView';
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login'
import Logout from './pages/Logout';
import PageNotFound from './pages/PageNotFound'
//added pages
import DashBoardAdmin from './pages/DashBoardAdmin';
import AddProduct from './pages/AddProduct';
import EditProduct from './pages/EditProduct';
import AllOrders from './pages/AllOrders'
import MyOrders from './pages/MyOrders'
//stylesheet
import './App.css';
import { UserProvider } from './UserContext'



function App() {
  
//const {user} = useContext(UserContext);
//console.log(user);


  //creating Global State ({})
  //state hook for the user state that is defined here for a global scope
  //also this is initialized as an object with properties from the localStorage
  //also this will be used to store the user information and will be used for validating
  //if a user is logged in on the app or not
  const [user, setUser] = useState({
    
   // email: localStorage.getItem("email")
    id: null,
    isAdmin: null
  
  }); 
  // Function for clearing the localStorage upon logout
  const unsetUser = () => {
          localStorage.clear();
  } 


  //useEffect s55
  useEffect(() => {

    fetch(`${process.env.REACT_APP_API_URL}users/details`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(res => res.json())
    .then(data => {

        if(typeof data._id !== "undefined") {
          setUser({
              id: data._id,
              isAdmin: data.isAdmin
          })
        } else {

          setUser({
            id: null,
            isAdmin: null
          })

        }
    })

}, []);



  return (

    <UserProvider value={ {user, setUser, unsetUser} }>
          <Router>
     
           <AppNavbar/>
            <Container  >
              <Routes>
                  <Route path='/' element={ <Home/>} />
                  <Route path="/admin" element={<DashBoardAdmin/>} />
                  <Route path="/addProduct" element={<AddProduct/>} />
                  <Route path="/allOrders" element={<AllOrders/>}/>
                  <Route path="/myOrders" element={<MyOrders/>}/>
                  <Route path="/editProduct/:productId" element={<EditProduct/>} />
                  <Route path='/product' element={ <Products/>} />
                  <Route path='/product/:productId' element={ <ProductView/>} />
                  <Route path='/register' element={ <Register/>} />
                  <Route path='/login' element={ <Login/>} />
                  <Route path='/logout' element={ <Logout/>} />
                  <Route path='*' element={<PageNotFound/>}/>

                  
              </Routes>
            </Container>
  
        </Router>
    </UserProvider>
  
  );
}

export default App;


/*  <Route path="/" element={<Home/>} />
                  <Route path="/admin" element={<AdminDashboard/>} />
                  <Route path="/addCourse" element={<AddCourse/>} />
                  <Route path="/editCourse/:courseId" element={<EditCourse/>} />
                  <Route path="/courses" element={<Courses/>} />
                  <Route path="/courses/:courseId" element={<CourseView/>} />
                  <Route path="/login" element={<Login/>} />
                  <Route path="/logout" element={<Logout/>} />
                  <Route path="/register" element={<Register/>} />
                  <Route path="*" element={<Error/>} />
 */